/**
 * Student Account
 * Student Account Api - Validation flow
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: dmartinez@ilernaonline.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';
import ConvocationResignationAcademicProgram from './ConvocationResignationAcademicProgram';
import ConvocationResignationStudent from './ConvocationResignationStudent';

/**
 * The ConvocationResignation model module.
 * @module model/ConvocationResignation
 * @version 1.0.0
 */
class ConvocationResignation {
    /**
     * Constructs a new <code>ConvocationResignation</code>.
     * @alias module:model/ConvocationResignation
     */
    constructor() { 
        
        ConvocationResignation.initialize(this);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj) { 
    }

    /**
     * Constructs a <code>ConvocationResignation</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/ConvocationResignation} obj Optional instance to populate.
     * @return {module:model/ConvocationResignation} The populated <code>ConvocationResignation</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new ConvocationResignation();

            if (data.hasOwnProperty('id')) {
                obj['id'] = ApiClient.convertToType(data['id'], 'Number');
            }
            if (data.hasOwnProperty('student')) {
                obj['student'] = ConvocationResignationStudent.constructFromObject(data['student']);
            }
            if (data.hasOwnProperty('comment')) {
                obj['comment'] = ApiClient.convertToType(data['comment'], 'String');
            }
            if (data.hasOwnProperty('resolution_comment')) {
                obj['resolution_comment'] = ApiClient.convertToType(data['resolution_comment'], 'String');
            }
            if (data.hasOwnProperty('status_id')) {
                obj['status_id'] = ApiClient.convertToType(data['status_id'], 'Number');
            }
            if (data.hasOwnProperty('academic_program')) {
                obj['academic_program'] = ConvocationResignationAcademicProgram.constructFromObject(data['academic_program']);
            }
            if (data.hasOwnProperty('created_at')) {
                obj['created_at'] = ApiClient.convertToType(data['created_at'], 'String');
            }
            if (data.hasOwnProperty('updated_at')) {
                obj['updated_at'] = ApiClient.convertToType(data['updated_at'], 'String');
            }
        }
        return obj;
    }


}

/**
 * The convocation resgination id.
 * @member {Number} id
 */
ConvocationResignation.prototype['id'] = undefined;

/**
 * @member {module:model/ConvocationResignationStudent} student
 */
ConvocationResignation.prototype['student'] = undefined;

/**
 * The comment provided by the student.
 * @member {String} comment
 */
ConvocationResignation.prototype['comment'] = undefined;

/**
 * The comment provided by secretary.
 * @member {String} resolution_comment
 */
ConvocationResignation.prototype['resolution_comment'] = undefined;

/**
 * The convocation resignation status.
 * @member {Number} status_id
 */
ConvocationResignation.prototype['status_id'] = undefined;

/**
 * @member {module:model/ConvocationResignationAcademicProgram} academic_program
 */
ConvocationResignation.prototype['academic_program'] = undefined;

/**
 * @member {String} created_at
 */
ConvocationResignation.prototype['created_at'] = undefined;

/**
 * @member {String} updated_at
 */
ConvocationResignation.prototype['updated_at'] = undefined;






export default ConvocationResignation;

